/**
 * Everything that can happen to a case voucher during its life. Together the
 * events form a complete ledger of a voucher: exactly one Created, followed by
 * any number of Booked/Moved, and optionally Deleted (which Restored reverses).
 *
 * Deposits get one extra entry: a deposit created directly on a case records
 * both Created and Booked, because booking it is also what resolves how it is
 * distributed. Other voucher types created on a case only record Created.
 */
export var CaseVoucherEventType;
(function (CaseVoucherEventType) {
    /** The voucher was created, with or without a case */
    CaseVoucherEventType["Created"] = "CREATED";
    /** The voucher was booked on a case it was not on before */
    CaseVoucherEventType["Booked"] = "BOOKED";
    /** The voucher was moved from one case to another */
    CaseVoucherEventType["Moved"] = "MOVED";
    /** The voucher was removed from its case without landing on another */
    CaseVoucherEventType["Unbooked"] = "UNBOOKED";
    /** The voucher was deleted */
    CaseVoucherEventType["Deleted"] = "DELETED";
    /** A deleted voucher was restored */
    CaseVoucherEventType["Restored"] = "RESTORED";
})(CaseVoucherEventType || (CaseVoucherEventType = {}));
//# sourceMappingURL=event-type.js.map